import type { MailboxInfo } from "owa-client-types";
import { type Capability } from "owa-capabilities";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getCurrentModule } from "owa-app-module-store";
import { Module } from "owa-workloads-module";
import { getOwaWorkload, type OwaWorkload } from "owa-workloads";

export const bizchatDrawerCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return (isGlobalFeatureEnabled("mon-copilot-bizchat-drawer") &&
            (getOwaWorkload() !== 4194304 ||
                isGlobalFeatureEnabled("addison-copilot-bizchat-drawer")));
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        const currentModule = getCurrentModule();
        return (currentModule === Module.Mail ||
            currentModule === Module.Calendar ||
            getOwaWorkload() === 2 ||
            getOwaWorkload() === 4194304);
    },
};
